import { api } from "../../../../api/api";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import AsyncSelectDropdown from "../../../../components/Forms/SelectDropdown/AsyncSelectDropown.component";
import { useRulesTableContext } from "../../pages/ProductDetail/ProductLineRulesTables/RulesTableContext";
import queryString from "query-string";
export default function PropertySearchDropdown({
  placeholder,
  multiselect,
  width = 250,
  onChange,
  label,
  className,
  disabled = false,
  rulesetFilter = [],
  size = "large",
  includePVAProperties = false,
  includeSubProperties = true,
}: {
  placeholder: string;
  name: string;
  multiselect: boolean;
  width?: number;
  onChange: (e: any) => void;
  label?: string;
  className?: string;
  disabled?: boolean;
  rulesetFilter?: string[];
  size?: "small" | "large";
  includePVAProperties?: boolean;
  includeSubProperties?: boolean;
}) {
  const { productLineId } = useParams<{ productLineId: string }>();
  const [timer, setTimer] = useState<any>();
  const { id: rulesTableId } = useRulesTableContext();

  const getPropertyOptions = async (nameQuery) => {
    try {
      const res = await api.getPropertiesLight(productLineId, {
        name: nameQuery,
        dataTypes: "",
        domains: "",
        ruleSets: rulesetFilter,
        tags: "",
        includePVAProperties,
        includeSubProperties,
        items: 50,
        page: 0,
        exclusiveRulesetFilter: true,
        regexNameMatch: true,
      });

      return res.data.properties.map((property) => ({
        value: property.id,
        label: property.name,
      }));
    } catch (error) {
      console.error("Error fetching property options:", error);
      return [];
    }
  };

  const promiseOptions = (query: string) =>
    new Promise<any>((resolve) => {
      if (timer) clearTimeout(timer);
      setTimer(
        setTimeout(() => {
          resolve(getPropertyOptions(query));
        }, 500)
      );
    });
  const [selectedOption, setSelectedOption] = useState<any>();
  const initalSelectedOption = queryString.parse(
    useLocation().search
  )?.propertyIds;

  useEffect(() => {
    // Only fetch if we have an initial option from URL and no selection yet
    if (initalSelectedOption && !selectedOption) {
      const initalSelectedOptionArray = Array.isArray(initalSelectedOption)
        ? initalSelectedOption
        : [initalSelectedOption];

      Promise.all(
        initalSelectedOptionArray.map((id) =>
          api.getPropertyLight(productLineId, id as string)
        )
      )
        .then((selectedOptions) => {
          const formattedOptions = selectedOptions.map((option) => ({
            value: option.data.id,
            label: option.data.name,
          }));

          setSelectedOption(formattedOptions);
        })
        .catch((error) => {
          // Handle error appropriately
          console.error("Failed to load initial property options:", error);
        });
    }
  }, []);

  const handleChange = (options) => {
    setSelectedOption(options);

    if (multiselect) {
      onChange(options.map((option) => option.value));
      return;
    }
    return onChange(options.value);
  };

  return (
    <AsyncSelectDropdown
      key={`${rulesTableId}-${JSON.stringify(rulesetFilter)}`}
      placeholder={placeholder}
      multiselect={multiselect}
      onChange={handleChange}
      loadOptions={promiseOptions}
      width={width}
      label={label}
      className={className}
      disabled={disabled}
      size={size}
      value={selectedOption}
    />
  );
}
